import { z } from 'zod';

// Buscador único de personas (QMS + LMS). Contrato de GET /api/v1/admin/people.

const qmsPersonSchema = z.object({
  source: z.literal('qms'),
  userId: z.string(),
  name: z.string(),
  email: z.string(),
  external: z.boolean(),
  status: z.string(),
});

const lmsPersonSchema = z.object({
  source: z.literal('lms'),
  /** null = aún no activa su cuenta del LMS: no se le puede asignar nada todavía. */
  authSubject: z.string().nullable(),
  name: z.string(),
  email: z.string(),
});

export const peopleSearchSchema = z.object({
  results: z.array(z.discriminatedUnion('source', [qmsPersonSchema, lmsPersonSchema])),
  lmsAvailable: z.boolean(),
});

export const peopleSearchResponseSchema = z.object({
  success: z.literal(true),
  data: peopleSearchSchema,
});

export type PeopleSearch = z.infer<typeof peopleSearchSchema>;
export type PersonResult = PeopleSearch['results'][number];

/** Lo que el usuario eligió en el buscador. */
export type PersonSelection =
  | { kind: 'qms'; userId: string; name: string; email: string }
  | { kind: 'lms'; authSubject: string; name: string; email: string }
  | { kind: 'invite'; email: string };
